import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://eiftfhctzxzjgmwwjwpg.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVpZnRmaGN0enh6amdtd3dqd3BnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ3NDkxMzksImV4cCI6MjA4MDMyNTEzOX0.r6WewZriYWLOe6SlBy8NTY7M4kF8rlPlw6tjNPcbXms';

export const supabase = createClient(supabaseUrl, supabaseKey);